import type { PageTextResolver } from '@st/document-viewer-kit'
import { createContext, useContext } from 'react'

const PageTextResolverContext = createContext<PageTextResolver | undefined>(undefined)

export const PageTextProvider = PageTextResolverContext.Provider

export function useResolvePageText(): PageTextResolver {
  const resolve = useContext(PageTextResolverContext)
  if (!resolve) {
    throw new Error('PageTextProvider is missing')
  }
  return resolve
}
